import CONFIG from '../config/config';

const getConversationRating = async (conversationId: string, publicKey: string, appId: string | undefined) => {
  let rating = 0;
  if (!publicKey) return rating;
  if (!appId) return rating;

  const cachedData = window.sessionStorage && window.sessionStorage.getItem(`dcinnovationChatBotConversationRating_${conversationId}_${appId}`);
  if (cachedData) return parseInt(cachedData);

  const myHeaders = new Headers();
  myHeaders.append('Ocp-Apim-Subscription-Key', publicKey);

  const requestOptions: RequestInit = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  try {
    const response = await fetch(CONFIG.domain_url + 'like/get_conversation_like/' + conversationId, requestOptions);
    const json = await response.json();

    if (window.sessionStorage) {
      window.sessionStorage.setItem(`dcinnovationChatBotConversationRating_${conversationId}_${appId}`, json.value);
    }

    rating = parseInt(json.value);
  } catch (error) {
    console.log(error);
  }

  return rating;
};

const createRating = (conversationId: string, value: number, publicKey: string) => {
  if (!publicKey) return;

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Ocp-Apim-Subscription-Key', publicKey);

  const raw = JSON.stringify({
    conversation_id: conversationId,
    value: value
  });

  const requestOptions: RequestInit = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
  };

  fetch(CONFIG.domain_url + 'like/create_like', requestOptions)
    .then((response) => response.text())
    .catch((error) => console.error(error));
};

const updateRating = (conversationId: string, value: number, publicKey: string) => {
  if (!publicKey) return;

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Ocp-Apim-Subscription-Key', publicKey);

  const raw = JSON.stringify({
    value: value
  });

  const requestOptions: RequestInit = {
    method: 'PUT',
    headers: myHeaders,
    body: raw,
  };

  fetch(CONFIG.domain_url + 'like/update_like/' + conversationId, requestOptions)
    .then((response) => response.text())
    .catch((error) => console.error(error));
};

const likeConversation = (conversationId: string, currentRating: number, publicKey: string) => {
  if (currentRating) return updateRating(conversationId, 1, publicKey);

  createRating(conversationId, 1, publicKey);
};

const dislikeConversation = (conversationId: string, currentRating: number, publicKey: string) => {
  if (currentRating) return updateRating(conversationId, -1, publicKey);

  createRating(conversationId, -1, publicKey);
};

export { likeConversation, dislikeConversation, getConversationRating };